const WaypointType = {
  UNLOADING: "UNLOADING",
  LOADING: "LOADING",
  NONE: "NONE",
  BOTH: "BOTH"
};

export default WaypointType;
